// onboardingFunnelAnalytics.js — onboarding funnel Product Events
//
// The 4 gap events that complete the executive onboarding funnel. Existing
// events are REUSED, not duplicated:
//   Invitation Accepted → onboarding_activate_invite   (Onboarding.js, existing)
//   Analysis Started     → analysis_run                (DealAnalyzer.js, existing)
//   Analysis Completed   → analysis_completed          (DealAnalyzer.js, existing)
//   Analysis Saved       → analysis_saved              (DealAnalyzer.js, existing)
//
// Thin wrappers over lib/analytics.track; track() injects the BL-025
// `environment` tag and no-ops when PostHog is unconfigured. PII-safe
// (ADR-040): flags/enums only — never address, contact, or free-text.

import { track } from './analytics';

// Funnel arrival at the dashboard (Dashboard Arrival Rate, M-011).
export function dashboardLoaded({ has_metrics } = {}) {
  track('dashboard_loaded', { has_metrics });
}

// First time the user reaches the property-search step (per session).
export function firstPropertySearch({ source } = {}) {
  track('first_property_search', { source });
}

// The user's return (2nd) session — return-usage signal (M-015).
export function secondSession(props = {}) {
  track('second_session', props);
}

// Terminal activation milestone (fired once per user at first analysis completion).
export function onboardingCompleted({ milestone } = {}) {
  track('onboarding_completed', { milestone });
}
